import React from 'react';
import { createTheme } from '@uhg-abyss/web/tools/theme';
import { createRouter } from '@uhg-abyss/web/tools/createRouter';
import { AbyssProvider } from '@uhg-abyss/web/ui/AbyssProvider';
import { Routes } from './routes';

const theme = createTheme('uhc');
const router = createRouter(Routes);

// Filter out warnings that are cluttering the console and we have no control of, makes it hard to see the errors we care more about
const filteredWarnings = [
  'Support for defaultProps will be removed from function components in a future major release.',
  '`DialogContent` requires a `DialogTitle` for the component to be accessible for screen reader users.',
];

export const browser = () => {
  if (process.env.NODE_ENV !== 'production') {
    const originalWarn = console.error;
    console.error = (...args) => {
      if (
        args &&
        args.length > 0 &&
        typeof args[0] === 'string' &&
        filteredWarnings.some((warning) => args[0].includes(warning))
      ) {
        return;
      }
      originalWarn(...args);
    };
  }
  return (
    <AbyssProvider theme={theme} router={router} />
  );
};
